// @flow
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

type UserType = {
    id?: string;
    _id?: string;
    name?: string;
    username?: string;
    email?: string;
    idOrganisation?: number;
};

export const userRoles = ['guest', 'user', 'admin'];

/**
 * The Util service is for thin, globally reusable, utility functions
 */

import {
    isFunction,
    noop,
} from 'lodash';
import { of } from 'rxjs';

/**
 * Return a callback or noop function
 *
 * @param  {Function|*} cb - a 'potential' function
 * @return {Function}
 */
export function safeCb(cb) {
    return isFunction(cb) ? cb : noop;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
    static parameters = [HttpClient];
    private apiURL = environment.backend;
    constructor(private http: HttpClient) {
        this.http = http;
    }

    query(): Observable<UserType[]> {
        return this.http.get(`${this.apiURL}/api/users/me`) as Observable<UserType[]>;
    }

    get(user: UserType = { id: 'me' }): Observable<UserType> {
        //console.log('entered get from auth.service');
        //return this.http.get(`/api/users/${user.id || user._id}`) as Observable<UserType>;
        return this.http.get(
            `${this.apiURL}/api/users/${user.id || user._id}`,
            {
                headers: new HttpHeaders({ 'authorization': 'Bearer ' + localStorage.getItem('id_token') })
            }
        ) as Observable<UserType>;
    }

    confirmToken(token) {
        return this.http.post(`${this.apiURL}/api/users/confirmToken`, { token }, httpOptions);
    }

    createOther(user: UserType): Observable<UserType> {
        return this.http.post(`${this.apiURL}/api/users/createother`, user, httpOptions);
    }

    getByEmail(userEmail): Observable<UserType> {
        return this.http.get(`/api/users/${userEmail}/ofuser`) as Observable<UserType>;
    }

    isValidToken(token): Observable<UserType> {
        return this.http.get(`/api/users/${token}/tokenofuser`) as Observable<UserType>;
    }

    create(user: UserType) {
        return this.http.post(`${this.apiURL}/api/users/`, user, httpOptions);
    }

    // changePasswordByToken(token, newPassword) {
    //     return this.http.post(`${this.apiURL}/api/users/${token}/password2`, { newPassword }, httpOptions);
    // }


    changePasswordByToken(token, newPassword) {
        return this.http.post(`${this.apiURL}/api/users/${token}/resetPasswordByToken`, { newPassword }, httpOptions);
    }

    changePassword(user, oldPassword, newPassword) {
        return this.http.put(`${this.apiURL}/api/users/${user.id || user._id}/password`, { oldPassword, newPassword }, httpOptions);
    }

    remove(user) {
        return this.http.delete(`${this.apiURL}/api/users/${user.id || user._id}`)
            .pipe(map(() => user));
    }

    insertTokenToEmail(email) {
        return this.http.post(`${this.apiURL}/api/users/insertTokenToEmail`, { email }, httpOptions);
    }

    registerUser(username, firstName, lastName, email,  password) {
        return this.http.post(`${this.apiURL}/api/users/registerUser`, { username, firstName, lastName, email, password }, httpOptions);
    }

    validatePasswordByToken(token) {
        return this.http.post(`${this.apiURL}/api/users/validateEmail`, { token }, httpOptions);
    }
}
